<template><div><h1 id="zahlungsverwendungen" tabindex="-1"><a class="header-anchor" href="#zahlungsverwendungen"><span>Zahlungsverwendungen</span></a></h1>
<p>Zahlungsverwendungen — Definiert die Zahlungsverwendungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle definiert die Zahlungsverwendungen. In dieser Tabelle können einem Bereich die Zahlungsarten und Kontierung zugeordnet werden. Zum Beispiel können in einer Kassa Barzahlung, Kredit-/Debitkarten und in einer anderen Kassa nur Barzahlungen definiert werden. Diese müssen noch in den Auftragsarten-Tabelle zugeordnet werden.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Zahlungsverwendungen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Zahlungsverwendungen</dt>
<dd>Zahlungsverwendungen</dd>
<dt>Zahlungsart</dt>
<dd><a class="link" href="ft.refdata.tblzahlungsarten.html" title="Zahlungsarten">Zahlungsarten</a></dd>
<dt>Konto</dt>
<dd>Konto</dd>
<dt>Kontobezeichnung</dt>
<dd>Kontobezeichnung</dd>
<dt>Kostenstelle</dt>
<dd>Kostenstelle</dd>
<dt>Kostenträger</dt>
<dd>Kostenträger</dd>
<dt>Bereich</dt>
<dd>Bereich</dd>
<dt>ID</dt>
<dd>ID</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblzahlungsarten.html" title="Zahlungsarten">Zahlungsarten</RouteLink></p>
</div></template>


